import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { UnitLinkedProduct } from '../../financial-insurance-macro-category';

export const mobileUnitLinkedColumns: Column<UnitLinkedProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
    key: 'equivalent',
    type: 'amount',
  },
];
